import { lazy } from "react";
import adminRoutes from "./AdminRoutes";
import doctorRoutes from "./DoctorRoutes";
import practiceRoutes from "./PracticeRoutes";
import {
  ADMIN_ROLE,
  DOCTOR_ROLE,
  PRACTICE_ROLE,
} from "./routeConfig";

const routes = [
  {
    path: "/",
    component: lazy(() => import("../Pages/Auth/LandingPage")),
    isPublic: true,
    exact: true,
    role: [ADMIN_ROLE, DOCTOR_ROLE, PRACTICE_ROLE],
  },
  {
    path: "/signIn/:roleType",
    component: lazy(() => import("../Pages/Auth/SignIn")),
    isPublic: true,
    exact: true,
    role: [ADMIN_ROLE, DOCTOR_ROLE, PRACTICE_ROLE],
  },
  {
    path: "/signUp",
    component: lazy(() => import("../Pages/Auth/SignUp")),
    isPublic: true,
    exact: true,
    role: [ADMIN_ROLE, DOCTOR_ROLE, PRACTICE_ROLE],
  },
  {
    path: "/otpVerification/:roleType",
    component: lazy(() => import("../Pages/Auth/OtpVerification")),
    isPublic: true,
    exact: true,
    role: [ADMIN_ROLE, DOCTOR_ROLE, PRACTICE_ROLE],
  },
  {
    path: "/forgotPassword/:roleType",
    component: lazy(() => import("../Pages/Auth/ForgotPassword")),
    isPublic: true,
    exact: true,
    role: [ADMIN_ROLE, DOCTOR_ROLE, PRACTICE_ROLE],
  },
  {
    path: "/resetPassword/:roleType",
    component: lazy(() => import("../Pages/Auth/ResetPassword")),
    isPublic: true,
    exact: true,
    role: [ADMIN_ROLE, DOCTOR_ROLE, PRACTICE_ROLE],
  },

  {
    path: "/chart/:trackingHash",
    component: lazy(() => import("../Pages/Auth/ChartRedirect")),
    isPublic: true,
    exact: true,
    role: [ADMIN_ROLE, DOCTOR_ROLE, PRACTICE_ROLE],
  },
]
  .concat(adminRoutes)
  .concat(practiceRoutes)
  .concat(doctorRoutes);

export default routes;
